import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React, { useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Coupon, CouponAlgorithm, CouponSource, CouponType } from "types";
import { NoTranslate } from "../../components/Common/NoTranslate";
import { EditCoupon } from "../../components/Coupon/EditCoupon";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Loader } from "../../components/Loader";
import { useSeller } from "../../hooks/useAccount";
import { useQueryParams } from "../../hooks/useQueryParams";
import { useResource } from "../../hooks/useResource";
import { Page } from "../Page";

export const EditCouponPage = () => {
    const { id } = useParams<{ id?: ID }>();
    const { data: coupon, isLoading } = useResource<Coupon>(["coupons", id], { expand: "purchaseRule" });
    const seller = useSeller();
    const params = useQueryParams();
    const history = useHistory();

    const handleCouponLinkClick = () => {
        history.push("/marketing/coupons");
    };

    const defaultCoupon: Coupon = useMemo(
        () => ({
            type: (params.get("type") as CouponType) ?? CouponType.DISCOUNT,
            name: "",
            limit: null,
            tags: [],
            excludeTaxFee: false,
            seller: { id: seller.id },
            algorithm: CouponAlgorithm.ABSOLUTE,
            amount: 0,
            source: CouponSource.XOLA,
            permissions: null,
        }),
        [params, seller],
    );

    return (
        <Page title="Coupons">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Marketing</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleCouponLinkClick}>Coupons</Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {coupon?.name ? <NoTranslate>{coupon.name}</NoTranslate> : "New Campaign"}
                        </Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    {isLoading ? <Loader /> : <EditCoupon coupon={id ? coupon! : defaultCoupon} />}
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
